<button 
  type="button" 
  (click)="toggleTheme()"
  class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:ring-offset-2"
  [class.bg-emerald-600]="isDarkMode"
  [class.bg-gray-200]="!isDarkMode"
  role="switch"
  [attr.aria-checked]="isDarkMode"
  [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
  
  <span class="sr-only">Toggle theme</span>
  
  <!-- Toggle circle with icon inside -->
  <span 
    class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out relative z-10 flex items-center justify-center"
    [class.translate-x-5]="isDarkMode"
    [class.translate-x-0]="!isDarkMode">
    
    <!-- Sun icon (light mode) -->
    <svg 
      *ngIf="!isDarkMode"
      class="h-3 w-3 text-gray-600 transition-opacity duration-200"
      fill="currentColor" 
      viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
    </svg>
    
    <!-- Moon icon (dark mode) -->
    <svg 
      *ngIf="isDarkMode"
      class="h-3 w-3 text-gray-600 transition-opacity duration-200"
      fill="currentColor" 
      viewBox="0 0 20 20">
      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
    </svg>
  </span>
</button> 